import { z } from 'zod';
import { isValidBrPhone } from '@/lib/format-br-phone';

export const CreateAccountFormSchema = z.object({
  name: z.string().min(1, 'Nome é obrigatório'),
  phone: z.string().refine(isValidBrPhone, 'Telefone inválido'),
  email: z.string().email('E-mail inválido'),
  storeName: z.string().min(1, 'Nome da loja é obrigatório'),
});

export type CreateAccountFormValues = z.infer<typeof CreateAccountFormSchema>;
